import api from './api';

const resource = 'Store/';

export const list = async (query = '') => {
  return await api.get(resource + 'List?PageSize=1000&' + query);
};

export const lookup = async (companyid) => {
  return await api.get(resource + 'Lookup?companyid=' + companyid);
};

/** Dashboard için: mağaza listesi + ayarları eksik mağaza (tax/phone) */
export const lookupForDashboard = async (companyid) => {
  return await api.get(resource + 'LookupForDashboard?companyid=' + companyid);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const getByCompanyId = async (companyid) => {
  return await api.get(resource + 'List?companyid=' + companyid);
};

export const upsert = async (body, config) => {
  return await api.post(resource + 'Upsert', body, config);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const deleteStoreLogoById = async (storeid) => {
  return await api.delete(resource + 'DeleteStoreLogo?storeid=' + storeid);
};

export const deleteTerminalLogoById = async (storeid) => {
  return await api.delete(resource + 'DeleteTerminalLogo?storeid=' + storeid);
};
export const upsertHours = async (body) => {
  return await api.post(resource + 'UpsertMenuHour', body);
};
export const upsertTierPrice = async (body) => {
  return await api.post(resource + 'UpsertTierPrice', body);
};
export const upsertExtraFee = async (body) => {
  return await api.post(resource + 'UpsertExtraFee', body);
};
export const squareLocationList = async (storeid) => {
  return await api.get(resource + 'ListSquareLocations?storeid=' + storeid);
};

const storeApi = {
  list,
  lookup,
  lookupForDashboard,
  getById,
  upsert,
  deleteById,
  getByCompanyId,
  deleteStoreLogoById,
  deleteTerminalLogoById,
  upsertHours,
  upsertTierPrice,
  upsertExtraFee,
  squareLocationList,
};

export default storeApi;
